import { Button, CircularProgress, Grid, IconButton, ListItemButton, TextField, Typography } from "@mui/material";
import { ContextNotification, severitys } from '../App';
import RtlProvider from "../Components/RtlProvider";
import React, { useEffect, useState } from "react";
import { SiTicktick } from "react-icons/si";
import EnumMapper from "../EnumMapper";
import UserApi from "../api/UserApi";
import helper from "../helper";
import staticData from "../data/StaticData";


const GenerateSurveyLink = () => {

        const { open, setOpen } = React.useContext(ContextNotification);
    const [ssn, setSsn] = useState('');
    const [loading,setLoading]=useState(false);
const[errorSSN,setErrorSSN]=useState(null);


    const HandleChangeSSN = (event) => {
        setSsn(event.target.value);
    }
    const SearchSurvey=()=>{
        setErrorSSN(null);
       if(!helper.SSNValidator(ssn))
        setErrorSSN( staticData.ssnError);
    else{
        setLoading(true);
  UserApi.GetSurveyList(ssn).then((res) => {
            if (res.data.data) {
       
            if(res.data.data.length>0)
 window.location.href =process.env.REACT_APP_URL_Survey+'/SurveyList/'+ssn;
       
              
          else
            setOpen({ IsEnable: true, Message:staticData.NoSurveyMessage, severity: severitys.info });
            }
             else if (res.data.message)
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.info });

        })
            .catch((err) => {
                if (err.response?.data) {
                    setOpen({ IsEnable: true, Message: err.response.data.title, severity: severitys.error });
                }
                else if (err.message) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
                }
            })
            .finally(() => setLoading(false));
        }
    }
    return (
        <>
            <RtlProvider>
                <Grid container spacing={0}>
                    <Grid item md={4}>
                        <Typography sx={{ display: "flex", marginTop: 4, marginBottom: 1, alignItems: "center", padding: 0 }}>
                            کد ملی خود را وارد کنید:
                        </Typography>
                    </Grid>
                   
                    <Grid item md={5}>
                        <TextField type="number"
                            margin="normal"
                            required
                            fullWidth
                            label="کدملی"
                            value={ssn}
                            autoFocus
                            onChange={(e) => HandleChangeSSN(e)}>
                           
                     </TextField>
                        

                        
                    </Grid>
                    <Grid item md={2}>
 <Button  variant="contained"
                                sx={{ width:'50%', mt:3,mr:1,ml:1 }}  disabled={(loading)||(ssn === '')} onClick={() => { SearchSurvey() }}>
                             {loading && <CircularProgress color="inherit" size="20px" sx={{ mx: '0.5rem' }} />}
                              <Typography sx={{ display: "flex", alignItems: "center" }}>
                                                               جستجو
                                                             </Typography>
                       
                        </Button>
                    </Grid>
 <p className="error">{errorSSN}</p>

                </Grid>




            </RtlProvider>
        </>
    );

}
export default GenerateSurveyLink;